import { useStaticQuery, graphql } from "gatsby"

const useArticleQuery = () => {
  const { allDatoCmsArticle } = useStaticQuery(graphql`
query Articles {
  allDatoCmsArticle(
  filter: {hideForLocale: {ne: true}}, 
  sort: {position: ASC}
) {
    nodes {
      id
      originalId
      title
      brand
      excerpt
      categories {
        title
      }
      slug
      permalink
      featureImage {
        ...InternalAssetProps
      }
      thumbnail {
        ...InternalAssetProps
      }
      catalogue {
        ...InternalAssetProps
      }
      related {
        id
        title
        brand
        excerpt
        categories {
          title
        }
        slug
        permalink
        featureImage {
          ...InternalAssetProps
        }
      }
    }
  }
}
  `)

  return allDatoCmsArticle.nodes
}

export default useArticleQuery